var _ellipse, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoffeeTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 8,
    rx: 7,
    ry: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 11l-1 8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 11l1 8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 19h6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffeeTable);
export default __webpack_public_path__ + "static/media/coffee-table.634a95d5f24554ea704cd1b9d1d8c48e.svg";
export { ForwardRef as ReactComponent };